<template>
	<div class="chat-container w-100 position-relative bg-light-page">
    <top-navbar title="Payment" :url="'/'+getMerchant().code+'/r/order-history'" />
    <div class="w-100" style="height:60px;"></div>
    <div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <ErrorMessage v-if="error != ''" :message="error" />
      <template v-else>
      	<div class="p-4">
      		<div class="rounded-6 bg-white box-shadow-bold mb-5 p-3" :key="trx_list_key">
      			<div 
			      	class="row no-gutters justify-content-start border-light-bottom py-2 bg-greenlight-hover"
			      	:class="{'border-light-bottom' : trx_index+1 != trx.length, 'border-bottom': trx_index+1 == trx.length,'bg-greenlight': trx_item.is_select}"  
			      	v-for="(trx_item,trx_index) in trx" 
			      	:key="trx_index">
			      	<div class="col-1 align-self-center">
			      		<div class="w-16px rounded border-2-green text-center delay mt-2px cursor-pointer  position-relative" :class="{'bg-green':trx_item.is_select}" @click="toggleSelectTrx(trx_index,'is_select')">
		              <img src="../../assets/img/icon/correct-white.png" width="10" class="position-relative" style="top: -8px">
		            </div>
			      	</div>
			    		<div @click="toggleSelectTrx(trx_index,'is_detail')" class="col-6 align-self-center">
			    			<p class="mb-0 body-3-3 font-bold">{{trx_item.invoice}}</p>
			    			<div class="w-100 d-table">
			    				<p class="mb-0 body-3-3 float-left" v-if="!trx_item.is_detail">{{countQty(trx_item.detail)}} Menu</p>
			    				<i v-if="!trx_item.is_detail" class="text-green float-right font-weight-bold text-12 mt-1 simple-icon-arrow-down"></i>
			    			</div>
			    		</div>
			    		<div @click="toggleSelectTrx(trx_index,'is_detail')" class="col-5 align-self-center text-right">
			    			<p class="mb-0 body-3-3 font-bold" v-if="!trx_item.is_detail">{{formatCurrency(trx_item.total_outstanding)}}</p>
			    			<p class="mb-0 body-3-3">{{formatDate(trx_item.service_date)}}</p>
			    		</div>
			    		<template v-if="trx_item.is_detail">
				    		<div class="col-11 offset-1 mt-2" @click="toggleSelectTrx(trx_index,'is_detail')">
				    			<div class="row no-gutters mb-1" v-for="detail_trx in trx_item.detail">
				    				<div class="col-8 align-self-center">
			    						<p class="mb-0 body-3-1"><span class="font-bold text-orange mr-2">{{detail_trx.qty}}X</span>{{detail_trx.name}}</p>
				    				</div>
				    				<div class="col-4 align-self-center text-right">
			    						<p class="mb-0 body-3-1">{{formatCurrency(countTotalPrice(detail_trx))}}</p>
				    				</div>
				    			</div>
				    			<div class="row no-gutters mt-1">
				    				<div class="col-5 align-self-center">
			    						<p class="mb-0 body-3-1 font-bold">{{$t('restaurant.total')}}</p>
				    				</div>
				    				<div class="col-7 align-self-center text-right">
			    						<p class="mb-0 body-3-1 font-bold">{{formatCurrency(trx_item.total_outstanding)}}</p>
				    				</div>
				    			</div>
				    		</div>
				    		<div class="col-12 text-center" @click="toggleSelectTrx(trx_index,'is_detail')">
				    			<i class="text-green font-weight-bold text-12 simple-icon-arrow-up"></i>
				    		</div>
			    		</template>
			      </div>

			      <!-- TOTAL BILL  -->
			      <div class="row no-gutters pt-3 pb-1">
			    		<div class="col-7">
			    			<p class="mb-0 body-2-2 font-bold">{{$t('hotel.concierge.total')}}</p>
			    		</div>
			    		<div class="col-5 text-right">
			    			<p class="mb-0 body-2-2 font-bold">{{formatCurrency(total_bill)}}</p>
			    		</div>
			      </div>

			      <!-- PAYMENT  -->
			      <div class="row no-gutters py-1">
			    		<div class="col-7" @click="test()">
			    			<div class="w-100 cursor-pointer">
			    				<p class="mb-0 d-inline-block align-middle body-2-2 font-bold text-danger">{{$t('restaurant.total-you-will-play')}}</p>
			    			</div>
			    		</div>
			    		<div class="col-5 text-right">
			    			<p class="mb-0 body-2-2 font-bold text-danger">{{formatCurrency(total_will_pay())}}</p>
			    		</div>
			      </div>

			      <!-- BALANCE
			      <div class="row no-gutters pt-1">
			    		<div class="col-7">
			    			<p class="mb-0 body-2-2 font-bold text-danger">{{$t('hotel.concierge.balance')}}</p>
			    		</div>
			    		<div class="col-5 text-right">
			    			<p class="mb-0 body-2-2 font-bold text-danger">{{formatCurrency(total_balance)}}</p>
			    		</div>
			      </div> -->
      		</div>

      		<div class="mb-5">
	      		<p class="mb-3 body-2-2 text-16 font-bold">{{$t('hotel.payment-method.choose-payment-method')}}</p>
	      		<div 
	            class="mb-3 px-3 py-2 rounded-6 delay cursor-pointer box-shadow-bold overflow-hidden"
	            :class="payment_method.selected.id == pm.id ? 'border-green bg-light-page h-auto' : 'bg-white'"
	            v-for="(pm,index) in payment_method.list" 
	            @click="selectPaymentMethod(pm)" 
	            style="background-color: #fff">
	            <div class="row no-gutters pt-1">
	              <div class="col-1">
	                <div class="w-16px rounded-100 border-2-green" style="margin-top: 12px;">
	                  <div class="w-8px rounded-100 position-relative mx-auto mt-2px" :class="{'bg-green': payment_method.selected.id == pm.id}"></div>
	                </div>
	              </div>
	              <div class="col-8">
	                <p class="mb-0 ml-2 body-2-2 font-bold text-16" :class="{'pt-2':pm.is_selected}">{{pm.name}}</p>
	                <p class="mb-0 pb-2 ml-2 body-2-2 text-12 text-truncate" v-if="payment_method.selected.id != pm.id" v-html="pm.description"></p>
	              </div>
	              <div class="col-3 text-right">
	                <img :src="pm.image_url" height="28">
	              </div> 
	              <div class="col-12" v-if="payment_method.selected.id == pm.id">
	                <p class="mb-0 ml-2 body-2-2 pb-2 text-12 pt-2" v-html="pm.description"></p>
	              </div>
	            </div>
	          </div>
      		</div>

          <template v-if="show_form">
	          <p class="mb-2 body-2-2 text-16 font-bold">{{$t('general.cc-required.title')}}</p>
	          <p class="mb-4 body-2-2 text-14 font-regular">{{$t('general.cc-required.desc')}}</p>
	          <div class="rounded-6 bg-white box-shadow-bold mb-5 p-3">
	          	<div class="w-100 mb-3">
		          	<p class="mb-1 body-2-2">{{$t('hotel.concierge.form.email')}}<span class="text-danger">*</span></p>
			          <input type="text" class="form-control body-2-2 text-14 mb-1" @change="validateForm" :class="{'border-danger':form.show_error && form.email.error != ''}" placeholder="example@guestapp.id" v-model="form.email.data">
			          <p class="mb-3 body-3-3-1 text-danger" v-if="form.show_error && form.email.error != ''">{{$t('warning-message.precheckin.'+form.email.error)}}</p>
	          	</div>
	          	<div class="w-100 mb-3">
		          	<p class="mb-1 body-2-2">{{$t('hotel.concierge.form.phone-number')}}<span class="text-danger">*</span></p>
			          <input type="text" class="form-control body-2-2 text-14 mb-1" @change="validateForm" :class="{'border-danger':form.show_error && form.phone_number.error != ''}" placeholder="+62 xxx xxx" v-model="form.phone_number.data">
			          <p class="mb-3 body-3-3-1 text-danger" v-if="form.show_error && form.phone_number.error != ''">{{$t('warning-message.precheckin.'+form.phone_number.error)}}</p>
	          	</div>
	          </div>
	        </template>

	        <div class="w-100">
	        	<div class="mb-3">
	        		<ErrorMessage v-if="push.error != ''" :message="push.error" />
	        	</div>
	        	<div class="row no-gutters pt-2">
              <div class="col-6 pt-1">
                <p class="mb-2 body-2-2 text-14 font-semibold">{{$t("hotel.concierge.unpaid-bill")}} : </p>
                <p v-if="payment_surcharge > 0" class="mb-0 body-2-2 text-14 font-semibold">{{$t('hotel.payment-surcharge')}} : </p>
              </div>
              <div class="col-6 pt-1 text-right">
                <p class="mb-0 body-2-2 text-16 font-bold text-danger">{{formatCurrency(total_will_pay())}}</p>
                <p v-if="payment_surcharge > 0" class="mb-0 body-2-2 text-16 font-semibold">{{formatCurrency(payment_surcharge)}}</p>
              </div>
              <div class="col-12">
                <div class="row no-gutters border-top mt-2 pt-2">
                  <div class="col-6">
                    <p class="mb-0 body-2-2 text-14 font-bold">{{$t('hotel.concierge.total-payment')}} : </p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 body-2-2 text-16 font-extrabold text-green">{{formatCurrency(total_will_pay()+payment_surcharge)}}</p>
                  </div>
                </div>
              </div>
            </div>
	        	<button @click="submitPayment" :disabled="push.loading" class="button-secondary w-100" :class="{'button-disabled': push.loading}">
		          <pulse-loader :loading="push.loading" color="#fff" v-if="push.loading"></pulse-loader>
		          <template v-else>
		            {{$t('restaurant.pay-now')}}
		          </template>
		        </button>
	        </div>
      	</div>
      </template>
    </template>

    <!-- pop up background -->
	  <transition name="fade">
	    <div class="position-relative" style="z-index: 1034" v-if="false">
	      <div class="row no-gutters justify-content-center">
	        <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
	          <div class="custom-container-fluid px-0">
	            <div class="row justify-content-center no-gutters">
	              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
	                <div class="w-100 py-2 px-2" style="height: 100vh;background-color: #00000066">
	                	<div class="bg-white mx-4 rounded-4" style="margin-top:35%">
	                    <div class="w-100 py-5 px-2">
	                      <div class="container px-4 text-center position-relative">
	                        <div class="rounded-100 my-2 w-20 mx-auto">
	                          <div class="bg-green rounded-100 mx-auto size-icon-in">
	                            <img src="../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
	                          </div>
	                        </div>
	                        <div class="pb-3">
	                          <p class="mb-0 body-2-2 text-18 text-green font-extrabold">Successfully made payment</p>
	                          <p class="mb-2 body-2-2">Thank you for making payment for your order, have a nice day</p>
	                          <router-link :to="'/'+getMerchant().code">
	                            <button type="button" class="button-primary text-green bg-white py-2 px-3 text-12 mt-3">{{$t('hotel.concierge.order-history')}}</button>
	                          </router-link>
	                        </div>
	                      </div>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </div>
	    </div>
	  </transition>
  </div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
  import {get,post,put} from '@/services/index.js';
  import {formatCurrency, formatDate} from '@/utils/index.js';
  import moment from 'moment'
  import { validationMixin } from "vuelidate";
  import config from '@/config/index.js';
  const { required, email,minLength } = require("vuelidate/lib/validators");

	export default{
		data(){
			return{
				is_load: true,
				error: '',
				payment_method:{
					list: [],
					selected: {}
				},
				trx: [],
				trx_selected: [],
				trx_list_key: 1,
				session_data:{},
				payment_surcharge: 0,
				form:{
					show_error: false,
					email: {
						data: '',
						error: ''
					},
					phone_number:{
						data: '',
						error: ''
					}
				},
				push:{
					loading: false,
					error: '',
					success: false
				}
			}
		},
		mixins: [validationMixin],
    validations: {
      form:{
        phone_number:{
        	data:{
	          required,
	          minLength: minLength(8),
        	}
        },
        email: {
        	data:{
	          required,
	          email
        	}
        }
      }
    },
		computed:{
			total_bill(){
				let total = 0
				this.trx.forEach(item=>{
					total += item.total_outstanding
				})
				return total
			},
			is_form_valid(){
				return this.form.email.error == '' && this.form.phone_number.error == '' ? true : false
			},
			show_form(){
				let validate_pm = this.payment_method.selected.id != '' && this.payment_method.selected.payment_method == 'CREDIT_CARD'
				let validate_user = !this.is_load && (this.session_data.customer_detail.email == null || this.session_data.customer_detail.phone_number == null)
				if(validate_pm && validate_user){
					return true
				}
				return false
			}
		},
		watch:{
			show_form(){
				if(this.show_form){
					this.validateForm()
				}
			}
		},
		mounted(){
			this.loadFirstData()
			// JOKUL
      let externalScript = document.createElement('script')
      externalScript.setAttribute('src', config.JOKUL_URL)
      document.head.appendChild(externalScript)
		},
		methods:{
			...mapGetters(['getMerchant','getRestaurantAuth']),
			...mapMutations(['setRestaurantAuth']),
			test(){
				console.log(this.total_will_pay)
				console.log(this.trx)
				console.log("==========================")
			},
			total_will_pay(){
				let total = 0
				this.trx.forEach(item=>{
					if(item.is_select === true){
						total += item.total_outstanding
					}
				})
				return total
			},
			selectPaymentMethod(pm=null){
				if(pm != null){
					this.payment_method.selected = pm
				}
        if(this.payment_method.selected.surcharge_type == 'FIXED_AMOUNT'){
          this.payment_surcharge = this.payment_method.selected.surcharge_value
        }else if(this.payment_method.selected.surcharge_type == 'PERCENT'){
          this.payment_surcharge = (this.total_will_pay()/100)*this.payment_method.selected.surcharge_value
        }else{
          this.payment_surcharge = this.payment_method.selected.surcharge_value
        }
			},
			formatDate(date){
				let data = moment(date).local()
        return moment(data).format('hh:mm, DD MMM YYYY');
      },
      formatCurrency(price){
        return formatCurrency(price)
      },
			loadFirstData(){
				this.is_load = true
				this.error = ''
				this.validateSession().then(session_res=>{
					if(session_res == true){
						this.getTrxData().then(trx_res=>{
							if(trx_res == true){
								this.getPaymentList().then(payment_res=>{
									if(payment_res != true){
										this.error = payment_res
									}
									this.is_load = false
								})
							}else{
								this.is_load = false
								this.error = trx_res
							}
						})
					}else{
						this.is_load = false
						this.error = session_res
					}
				})
			},
			countQty(data){
				let total = 0
				data.forEach(item=>{
					total += item.qty
				})
				return total
			},
			countTotalPrice(data){
				let total = ((data.qty*data.price)+data.taxes+data.service)-data.discount
				return total
			},
			toggleSelectTrx(index,key){
				this.trx[index][key] = !this.trx[index][key]
				if(key == 'is_select'){
					if(this.total_will_pay() == 0){
						this.payment_surcharge = 0
					}else{
						this.selectPaymentMethod()
					}
				}
				this.trx_list_key++
			},
			validateForm(){
				if(this.$v.form.phone_number.data.$invalid){
          if(!this.$v.form.phone_number.required){
            this.form.phone_number.error = 'required-phone-number'
          }else{
            this.form.phone_number.error = 'invalid-phone-number'
          }
        }else{
          this.form.phone_number.error = ''
        }
        if(this.$v.form.email.data.$invalid){
          if(!this.$v.form.email.required){
            this.form.email.error = 'required-email'
          }else{
            this.form.email.error = 'invalid-email'
          }
        }else{
          this.form.email.error = ''
        }
      },
      submitPayment(){
      	if(!this.push.loading){
      		this.push.loading = true
      		this.push.error = ''
      		if(this.total_will_pay() == 0){
      			this.push.error = this.$t('restaurant.please-select-atleast-one-trx')
      			this.push.loading = false
      		}
      		else if(this.payment_method.selected.id == ''){
    				this.push.error = this.$t('restaurant.please-select-payment-method')
      			this.push.loading = false
    			}else if(this.show_form){
      			this.form.show_error = !this.is_form_valid	
      			if(!this.is_form_valid){
      				this.push.loading = false
      			}else{
      				this.updateSession().then(update_session_res=>{
      					if(update_session_res){
      						this.postPayment().then(payment_res=>{
      							if(payment_res.success){
      								this.excPaymentResult(payment_res)
      							}else{
      								this.push.error = payment_res.message
      								this.push.loading = false
      							}
      						})
      					}else{
      						this.push.error = update_session_res
      						this.push.loading = false
      					}
      				})
      			}
      		}else{
      			this.postPayment().then(payment_res=>{
							if(payment_res.success){
								this.excPaymentResult(payment_res)
							}else{
								this.push.error = payment_res.message
								this.push.loading = false
							}
						})
      		}
      	}
      },
      excPaymentResult(res){
      	console.log("res : ", res)
      	if(this.payment_method.selected.bank_name == 'JOKUL_DOKU'){
          if(this.payment_method.selected.payment_method == 'VIRTUAL_ACCOUNT'){
            this.$router.push({
              name: 'RestaurantPaymentResult',
              params:{
                tx_payment_id : res.tx_order_id
              }
            })
          }else{
            loadJokulCheckout(res.payment.url)
          }
        }else if(this.payment_method.selected.bank_name == 'MIDTRANS'){ 
         
          let scriptTag = document.createElement('script');
          scriptTag.src = config.MIDTRANS_URL
          scriptTag.setAttribute('data-client-key', res.payment.client_key);
          document.head.appendChild(scriptTag);
          scriptTag.onload = function(){
            window.snap.pay(res.payment.token)
          }
        } else{
          this.$router.push({
            name: 'RestaurantPaymentResult',
            params:{
              tx_payment_id : res.tx_order_id
            }
          })
        }
      },

			validateSession(){
	    	return new Promise(done=>{
		    	get("CORE_RESTO","v2/session/validate",{
						merchant_id: this.getMerchant().id
					},'restaurant_session').then(response=>{
						let res = response.data
						if(res.success){
							this.session_data = res.data
							done(true)
						}else{
							let params = [
								{
									key: 'name',
					    		value: ''	
								},
								{
									key: 'session',
					    		value: ''	
								},
							]
							this.setRestaurantAuth(params)
							done('Your session is expired')
						}
					})
	    	})
	    },
	    getTrxData(){
	    	return new Promise(done=>{
		    	get("CORE_RESTO","v2/session/bill",{
						merchant_id: this.getMerchant().id
					},'restaurant_session').then(response=>{
						let res = response.data
						if(res.success){
							this.trx = []
							res.data.forEach(item=>{
								if(item.total_outstanding > 0){
									this.trx.push(item)
								}
							})
							this.trx = this.trx.map(x=>{
			          x.is_select = true
			          x.is_detail = this.trx.length == 1 ? true : false 
			          return x
			        })
							done(true)
						}else{
							done(res.message)
						}
					})
	    	})
	    },
	    getPaymentList(){
	    	return new Promise((done)=>{
          get("CORE_RESTO","v2/merchant/"+this.getMerchant().id+"/payment-option")
          .then(response=>{
            let res = response.data
            if (res.success) {
              this.payment_method.list = res.data
              this.payment_method.selected = {id:''}
              done(true)
            }else{
            	done(res.message)
            }
          })
        })
	    },
	    updateSession(){
	    	return new Promise(done=>{
	    		let params = {
	    			merchant_id: this.getMerchant().id,
				    name: this.getRestaurantAuth().name,
				    email: this.form.email.data,
				    phone_number: this.form.phone_number.data
	    		}
	    		put(
	    			"CORE_RESTO",
	    			"v2/session/update-profile",
	    			params,
	    			"restaurant_session").then(response=>{
	    				let res = response.data
	    				if(res.success){
	    					done(true)
	    				}else{
	    					done(res.message)
	    				}
	    			})
	    	})
	    },
	    postPayment(){
	    	return new Promise(done=>{
	    		let params = {
	    			merchant_id: this.getMerchant().id,
	    			trx_id_list: [],
	    			amount: this.total_will_pay()+this.payment_surcharge,
	    			payment_details:{
	    				id: this.payment_method.selected.id,
	    				payment_method: this.payment_method.selected.payment_method,
	    				bank_name: this.payment_method.selected.bank_name,
	    				payment_channel: this.payment_method.selected.payment_channel,
	    			}
	    		}

	    		this.trx.forEach(item=>{
	    			if(item.is_select){
	    				params.trx_id_list.push(item.id)
	    			}
	    		})

	    		post(
	    			"CORE_RESTO",
	    			"v2/tx-guest-bill-payment",
	    			params,
	    			"restaurant_session").then(response=>{
	    				done(response.data)
	    			})
	    	})
	    }
		}
	}
</script>
<style>
	.bg-greenlight{
		background-color: rgb(243, 255, 244)
	}
	.bg-greenlight-hover:hover{
		background-color: rgb(243, 255, 244)
	}
</style>


// WEBPACK FOOTER //
// src/pages/restaurant/PaymentBill.vue